class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.closest("carousel-slider");
    this.recommendationsUrl = this.getAttribute("data-recommendations-url");
    this.recommendationsIds = this.getAttribute("data-recommendations-ids");
    this.loadPromise = null;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.getRecommendations();
    };

    this.observer = new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 1200px 0px",
    });
    this.observer.observe(this);
  }

  // Always returns a promise and only ever fetches once, so callers can await
  // it to force the carousel in ahead of the observer firing.
  getRecommendations() {
    if (!this.loadPromise) {
      if (this.observer) this.observer.unobserve(this);
      this.loadPromise = this.loadRecommendations();
    }

    return this.loadPromise;
  }

  loadRecommendations() {
    if (this.recommendationsUrl) {
      this.innerHTML = "";
      return this.addRecommendations(this.recommendationsUrl);
    }

    let ids = this.recommendationsIds ? this.recommendationsIds.split(",") : [];

    if (window.cart.items_count === 0 || window.cart.items_count === undefined) {
      const defaultProductId = `${window.productRecommendationId}`;
      ids = [defaultProductId];
    }

    if (!ids.length) return Promise.resolve();

    const productLimit = Math.round(10 / ids.length);
    this.innerHTML = "";

    return Promise.all(
      ids.map((productId) => {
        let intent;
        if (this.closest('#section-mini-cart-recommendations') || window.template == 'cart') {
          intent = 'complementary';
        } else if (this.closest('.section-carousel')) {
          intent = 'related';
        }

        return this.addRecommendations(
          window.recommendationsUrl +
            `&product_id=${productId}&limit=${productLimit}&intent=${intent}`
        );
      })
    );
  }

  addRecommendations(url) {
    return fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("div");
        this.innerHTML += recommendations.innerHTML;
        return;
      })
      .finally(() => {
        if (this.carousel) this.carousel.dispatchEvent(new Event("trigger-init"));
      })
      .catch((e) => console.error(e));
  }
}

fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    window.cart = cart;
    window.cart.items_count = cart.item_count;
  })
  .then(() => {
    // Initialize ProductRecommendations after cart data is fetched
    customElements.define('product-recommendations', ProductRecommendations);
  });
